// ============================================
// FILE: /frontend/src/components/listings/ChamaEligibleBadge.jsx
// PURPOSE: Badge to show listing is eligible for group buying
// UPDATED: Eligibility based on seller opt-in and allowed categories/sub-types
// ============================================

import { Users, Sparkles } from 'lucide-react';
import { Badge } from '../ui/badge';

export default function ChamaEligibleBadge({ 
  listing, 
  showInterestCount = false, 
  interestCount = 0,
  size = 'default' 
}) {
  // Seller must opt in
  if (!listing.allowGroupBuy) return null;

  // Allowed categories/sub-types
  const allowedCategories = {
    PROPERTY: [
      "Off Plan",
      "Joint Ventures",
      "Commercial Property for Sale",
      "Godowns and Warehouses for Sale"
    ]
  };

  // Check if listing is eligible
  const category = listing.category;
  const subType = listing.subType || listing.title; // fallback to title if no subType

  if (
    !allowedCategories[category] ||
    !allowedCategories[category].some(
      allowed => allowed.toLowerCase() === subType.toLowerCase()
    )
  ) {
    return null;
  }

  const isSmall = size === 'sm';

  return (
    <div className="flex flex-col gap-1">
        <div className={`${
  isSmall 
    ? 'text-[9px] px-2 py-0.5' 
    : 'text-xs px-2.5 py-1.5'
      } bg-yellow-500 text-white font-semibold rounded shadow-md`}>
          Join Group Buy Option
        </div>
      
      {showInterestCount && interestCount > 0 && (
        <p className={`${isSmall ? 'text-[9px]' : 'text-[10px] sm:text-xs'} text-muted-foreground`}>
          {interestCount} {interestCount === 1 ? 'person' : 'people'} interested
        </p>
      )}
    </div>
  );
}
